<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        advanced
        :resource="$sdk.ratesurcharge"
        :primary-fields="[ 'carrier', 'type', 'date_start', 'date_end', 'active' ]"
        :setup-fields="{ 'group.indices.account': setupGroupIndicesAccountFilterable, date_end: setupDateEndFilterable }"
        :hidden-fields="[ 'group', 'group.indices.account' ]"
        @ready="$refs.table.loadTable()"
        @apply="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <SurchargesTable
          ref="table"
          :filters="filters"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import SurchargesTable from '@/components/Application/Manage/Surcharges/SurchargesTable'
import { IS, IS_EMPTY } from '@/plugins/sdk/Filter'

export default {
  components: {
    Filters,
    SurchargesTable
  },
  data () {
    return {
      title: 'Surcharges',
      breadcrumb: {
        name: 'Surcharges',
        route: { name: 'manage-accounts-account-surcharges' }
      },
      actions: [],
      filters: [
        'group.indices.account is ' + this.$route.params.accountId
      ]
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  },
  methods: {
    setupDateEndFilterable (filterable) {
      filterable.filter.operator = IS_EMPTY
    },
    setupGroupIndicesAccountFilterable (filterable) {
      filterable.filter.operator = IS
      filterable.filter.value = this.$route.params.accountId
    }
  }
}
</script>
